export interface UiPreferencesState {
    /** Raw preferences object stored on the backend (key → value) */
    preferences: Record<string, any> | null;
    loading: boolean;
    loaded: boolean;
    error: string | null;
}

export const uiPreferencesInitialState: UiPreferencesState = {
    preferences: null,
    loading: false,
    loaded: false,
    error: null,
};
